import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { BalanceOptions, BalanceOptionsForVolumeValues } from '../types/RecipeIngredients';
var initialOption = {
  key: '',
  code: ''
};
var initialBalanceOption = {
  key: BalanceOptions.withoutBalance,
  code: ''
};
export var recipeIngredientsStore = reactive({
  ingredients: [],
  equipmentProducts: [],
  balanceOption: initialBalanceOption,
  volumeOption: initialOption,
  findIngredient: function findIngredient(sku) {
    return this.ingredients.find(function (product) {
      return product.sku == sku;
    });
  },
  findEquipment: function findEquipment(sku) {
    return this.equipmentProducts.find(function (product) {
      return product.sku == sku;
    });
  },
  setIngredients: function setIngredients(ingredients) {
    this.ingredients = ingredients;
  },
  setEquipmentProducts: function setEquipmentProducts(equipmentProducts) {
    this.equipmentProducts = equipmentProducts;
  },
  setBalanceOption: function setBalanceOption(balanceOption) {
    this.balanceOption = balanceOption;
  },
  setVolumeOption: function setVolumeOption(volume) {
    this.volumeOption = volume;
  },
  reset: function reset() {
    this.ingredients = [];
    this.equipmentProducts = [];
    this.balanceOption = initialBalanceOption;
    this.volumeOption = initialOption;
  },
  findQuantity: function findQuantity(quantities, phase) {
    var _this$volumeOption, _this$balanceOption, _volumeValues$fields2, _volumeValues$fields3;
    var volumeCode = (_this$volumeOption = this.volumeOption) === null || _this$volumeOption === void 0 ? void 0 : _this$volumeOption.code;
    var volumeValues = quantities.find(function (quantity) {
      var _quantity$fields, _quantity$fields$Quan, _quantity$fields$Quan2;
      return (quantity === null || quantity === void 0 ? void 0 : (_quantity$fields = quantity.fields) === null || _quantity$fields === void 0 ? void 0 : (_quantity$fields$Quan = _quantity$fields.QuantityToCreate) === null || _quantity$fields$Quan === void 0 ? void 0 : (_quantity$fields$Quan2 = _quantity$fields$Quan.sys) === null || _quantity$fields$Quan2 === void 0 ? void 0 : _quantity$fields$Quan2.id) == volumeCode;
    });
    var amountType = "amount".concat(BalanceOptionsForVolumeValues[(_this$balanceOption = this.balanceOption) === null || _this$balanceOption === void 0 ? void 0 : _this$balanceOption.code]);
    if (phase) {
      var _volumeValues$fields, _volumeValues$fields$, _volumeValueWithPrope;
      var volumeValueWithProperPhase = volumeValues === null || volumeValues === void 0 ? void 0 : (_volumeValues$fields = volumeValues.fields) === null || _volumeValues$fields === void 0 ? void 0 : (_volumeValues$fields$ = _volumeValues$fields.amounts) === null || _volumeValues$fields$ === void 0 ? void 0 : _volumeValues$fields$.find(function (volume) {
        var _volume$fields;
        return ((_volume$fields = volume.fields) === null || _volume$fields === void 0 ? void 0 : _volume$fields.phase) == phase;
      });
      return volumeValueWithProperPhase === null || volumeValueWithProperPhase === void 0 ? void 0 : (_volumeValueWithPrope = volumeValueWithProperPhase.fields) === null || _volumeValueWithPrope === void 0 ? void 0 : _volumeValueWithPrope[amountType];
    }
    return volumeValues === null || volumeValues === void 0 ? void 0 : (_volumeValues$fields2 = volumeValues.fields) === null || _volumeValues$fields2 === void 0 ? void 0 : (_volumeValues$fields3 = _volumeValues$fields2.amounts) === null || _volumeValues$fields3 === void 0 ? void 0 : _volumeValues$fields3.map(function (amount) {
      var _amount$fields;
      return (_amount$fields = amount.fields) === null || _amount$fields === void 0 ? void 0 : _amount$fields[amountType];
    });
  }
});